<template>
  <div>
    <v-progress-linear
        v-model="power"
        color="red"
        rounded
        height="25"
    ></v-progress-linear>
  </div>
</template>
<script>
export default {
  props: {
    power: Number
  },
  data: () => ({

  }),
  methods: {

  }
}
</script>